import type { PluginExports } from 'graylog-web-plugin/plugin';

import SecurityEventsPage from 'security-app/components/SecurityEvents/Alerts';

const securityEventsBindings: PluginExports = {
  'views.components.securityEventsPage': [
    {
      component: SecurityEventsPage,
      key: 'securityEventsPage',
    },
  ],
};

export default securityEventsBindings;
